import { useState } from 'react';

import { trans, useSoyuzFlag } from '@spotahome/soyuz/client';
import { Button, Collapsible } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import { TENANT_CONFIG, TENANT_CONFIG_NEW } from '../../constants';

import ContactUsHeader from '../ContactUsHeader';
import './ContactSections.scss';

const getSectionsFromParams = category =>
  Object.entries(TENANT_CONFIG[category]);

const ContactSections = () => {
  const [sectionOpen, setSectionOpen] = useState('');
  const isNewRouting = useSoyuzFlag('ContactFormNewNavigation').isOn();

  const { payload, send } = useStateMachineContext();
  const { role, categoryId } = payload;

  const formSections = getSectionsFromParams(categoryId);
  const categoryReasons = TENANT_CONFIG_NEW[categoryId] || [];
  const baseLocoKey = isNewRouting
    ? `contact-us.${role}.new`
    : `contact-us.${role}`;

  const handleSectionAccordionClick = sectionId => {
    if (sectionId !== sectionOpen) {
      setSectionOpen(sectionId);
    }
  };

  const handleItemClick = (sectionId, reasonId) => {
    send('SELECT', { sectionId, reasonId });
  };

  const renderOldFormat = () =>
    formSections.map(([sectionId, reasons]) => (
      <Collapsible
        key={sectionId}
        isCollapsed={sectionId !== sectionOpen}
        onCollapsedChange={() => handleSectionAccordionClick(sectionId)}
        isRounded
        hasIcon
        dataTest="contact-subcategories"
        className="contact-subcategories__accordion"
        headerClassName="contact-subcategories__header"
        bodyClassName="contact-subcategories__body"
        renderHeader={() => trans(`${baseLocoKey}.${sectionId}`)}
        renderBody={() => (
          <ul className="contact-subcategories__list">
            {reasons.map(reasonId => (
              <li key={reasonId}>
                <Button
                  color="primary"
                  size="large"
                  alt
                  fullWidth
                  onClick={() => handleItemClick(sectionId, reasonId)}
                  className="contact-us-form__button--alt"
                  dataTest={`${reasonId}-button`}
                >
                  {trans(`${baseLocoKey}.${reasonId}`)}
                </Button>
              </li>
            ))}
          </ul>
        )}
      />
    ));

  const renderNewFormat = () => (
    <ul className="contact-subcategories__list">
      {categoryReasons.map(reasonId => (
        <li key={reasonId}>
          <Button
            color="primary"
            size="large"
            alt
            fullWidth
            onClick={() => handleItemClick(null, reasonId)}
            className="contact-us-form__button--alt"
            dataTest={`${reasonId}-button`}
          >
            {trans(`${baseLocoKey}.${reasonId}`)}
          </Button>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader
        title={trans(`${baseLocoKey}.${categoryId}`)}
        onBack={() => send('BACK')}
      />
      {isNewRouting ? renderNewFormat() : renderOldFormat()}
    </div>
  );
};

export default ContactSections;
